// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_hBk","cls2":"ReportList-cls2_snJ ReportList-cls1_hBk"};